import React from 'react'
import { Modal } from '@enamelai/design-system'

type ChartingAddChartModalProps = {
  show: boolean
  onCancel: () => void
  onDiscardAndContinue: () => void
}

const ChartingAddChartModal: React.FC<ChartingAddChartModalProps> = ({
  show,
  onCancel,
  onDiscardAndContinue,
}) => (
  <Modal
    open={show}
    onClose={onCancel}
    size="xs"
    title="Add a chart?"
    description={[
      'Any unsaved changes to the current chart will be lost.',
      'Do you want to proceed?',
    ]}
    primaryLabel="Discard and Continue"
    secondaryLabel="Cancel"
    primaryDestructive
    onPrimaryClick={onDiscardAndContinue}
    onSecondaryClick={onCancel}
  />
)

export default ChartingAddChartModal
